// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"723d7839","698":"7d0524b4"}[chunkId] + ".chunk.js";
};